import React, { useEffect } from "react";
import AppRoutes from "./routes/AppRoutes";
import { CartProvider } from "./components/common/cartpage/CartContext";
import "./styles/globals.css";
import "react-phone-input-2/lib/style.css";

function App() {
  return (
    <CartProvider>
      <div className="font-sans antialiased bg-white text-black">
        <AppRoutes />
      </div>
    </CartProvider>
  );
}

export default App;
